module.exports = __webpack_public_path__ + "static/media/Grande-Vista-Estates-2nd-Amendment-to-Master-Deed.95c1e44e.pdf";